import PropTypes from 'prop-types';
import { Navigate, Outlet } from 'react-router-dom';
import { useOrderPerformanceFeatures } from '../../providers/OrderPerformanceFeaturesProvider';

/**
 * 订单绩效子功能路由守卫（未开通时重定向首页）
 * @param {'rulesManagement'|'bulkRematch'} feature
 */
const OrderPerformanceFeatureRoute = ({ feature }) => {
	const features = useOrderPerformanceFeatures();
	if (!features.module || !features[feature]) {
		return <Navigate to='/' replace />;
	}
	return <Outlet />;
};

OrderPerformanceFeatureRoute.propTypes = {
	feature: PropTypes.oneOf(['rulesManagement', 'bulkRematch']).isRequired,
};

export default OrderPerformanceFeatureRoute;
